import React from "react";
import "./TableMobile.css";

/**
 * TableMobile - componente de tabela adaptado para mobile
 * Props:
 *  - data: array de objetos (dados)
 *  - columns: array de { key, label, render? }
 *  - getActionItems: função (id, item) => [{label, action}]
 *  - filters: elemento React (opcional)
 *  - loading: boolean
 *  - error: string
 *  - currentPage, totalPages, onPageChange (opcional)
 */
function TableMobile({
  data = [],
  columns = [],
  getActionItems,
  filters,
  loading = false,
  error = null,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
}) {
  return (
    <div className="table-mobile-container">
      {filters && <div className="table-mobile-filters">{filters}</div>}
      {loading && <div className="table-mobile-loading">Carregando...</div>}
      {error && <div className="table-mobile-error">{error}</div>}
      {!loading && !error && data.length === 0 && (
        <div className="table-mobile-empty">Nenhum registro encontrado.</div>
      )}
      <div className="table-mobile-list">
        {data.map((item, idx) => (
          <div className="table-mobile-card" key={item.id || idx}>
            {columns.map((col) => (
              <div className="table-mobile-row" key={col.key}>
                <span className="table-mobile-label">{col.label}:</span>
                <span className="table-mobile-value">
                  {col.render ? col.render(item[col.key], item) : item[col.key] ?? "-"}
                </span>
              </div>
            ))}
            {getActionItems && (
              <div className="table-mobile-actions">
                {getActionItems(item.id, item).map((action, i) => (
                  <button
                    key={i}
                    className="table-mobile-action-btn"
                    onClick={action.action}
                  >
                    {action.label}
                  </button>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
      {totalPages > 1 && onPageChange && (
        <div className="table-mobile-pagination">
          <button onClick={() => onPageChange(1)} disabled={currentPage === 1}>{"<<"}</button>
          <button onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>{"<"}</button>
          <span>Página {currentPage} de {totalPages}</span>
          <button onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>{">"}</button>
          <button onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>{">>"}</button>
        </div>
      )}
    </div>
  );
}

export default TableMobile;
